import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import type {MergeBoxPageData} from '../payloads/merge-box'
import {usePageDataContext} from '@github-ui/pull-request-page-data-tooling/page-data-context'
import {fetchWithTracing} from '../../helpers/fetch-with-tracing'
import {useQuery, useQueryClient, useSuspenseQuery, queryOptions} from '@github-ui/react-query'
import type {MergeMethod} from '../../types'

export function useMergeBoxPageDataQueryKey() {
  const {basePageDataUrl} = usePageDataContext()
  return [PageData.mergeBox, `basePageDataURL:${basePageDataUrl}`]
}

function useMergeBoxPageDataOptions({
  mergeMethod,
  bypassRequirements = false,
}: {
  mergeMethod: MergeMethod
  bypassRequirements?: boolean
}) {
  const searchParams = new URLSearchParams()
  searchParams.append('merge_method', mergeMethod)
  searchParams.append('bypass_requirements', bypassRequirements.toString())
  const apiURL = usePageDataUrl(PageData.mergeBox, searchParams.toString())
  const queryKey = useMergeBoxPageDataQueryKey()
  const queryClient = useQueryClient()

  return queryOptions({
    queryKey,
    queryFn: async () => {
      return fetchWithTracing<MergeBoxPageData>(apiURL, queryKey, queryClient)
    },
    staleTime: Infinity,
  })
}

export function useMergeBoxPageData({
  mergeMethod,
  bypassRequirements = false,
}: {
  mergeMethod: MergeMethod
  bypassRequirements?: boolean
}) {
  return useQuery(useMergeBoxPageDataOptions({mergeMethod, bypassRequirements}))
}

export function useSuspenseMergeBoxPageData({
  mergeMethod,
  bypassRequirements = false,
}: {
  mergeMethod: MergeMethod
  bypassRequirements?: boolean
}) {
  return useSuspenseQuery(useMergeBoxPageDataOptions({mergeMethod, bypassRequirements}))
}
